import { Text } from '@ui/themed';
import { t } from 'i18next';

export function OptionalDetail({ value }: { value?: string }) {
  return value ? (
    <Text>{value}</Text>
  ) : (
    <Text variant="secondary">{t('labels:none_selected')}</Text>
  );
}
